import { Box, Container, Grid, Typography } from "@mui/material";
import ReviewsCard from "./ReviewsCard";
import React from "react";
import female from "../../../assets/female.png";
import male from "../../../assets/person.png";



export default function Reviews() {
    const reviewsData = [
        {
            id: 1,
            icon: female,
            rating: 5.0,
            title: "Excellent Service",
            comment: "Had a very good experience at the clinic. The doctor was experienced, listened patiently, and provided clear guidance. The nursing staff and overall facility were also excellent—supportive, professional, and attentive throughout. Truly appreciate the care and service.",
            reviewer: "Ankita Bhagat",
            date: "June 20, 2025"
        },
        {
            id: 2,
            icon: male,
            rating: 5.0,
            title: "Very Professional",
            comment: "My experience with Dr. Amit was truly outstanding. He is incredibly experienced, and you can tell right away that he genuinely cares about his patients. From the moment I arrived, he made me feel comfortable and listened carefully to all my concerns. His approach to treatment was thorough, and he explained everything in detail, making sure I understood all the options available. It's rare to find a doctor who not only has such expertise but also takes the time to ensure you're fully informed and at ease. I felt well taken care of throughout the entire process.",
            reviewer: "Sandeep Kumar",
            date: "April 18, 2025"
        },
        {
            id: 3,
            icon: female,
            rating: 5.0,
            title: "Outstanding Care",
            comment: "The clinic itself is modern, clean, and well-maintained. I was amazed at how efficiently everything ran. I didn’t have to wait long at all, and everything was handled smoothly and on time.",
            reviewer: "Xin Liu",
            date: "June 15, 2025"
        },
        {
            id: 4,
            icon: female,
            rating: 4.5,
            title: "Had a wonderful Experience",
            comment: "I had a wonderful experience with Dr Amit Vishen.. He explained everything to me with such clarity and patience, making me feel completely at ease. I truly appreciate the time he took to ensure I understood every detail. Thank you for your excellent care!",
            reviewer: "Shilpa Choudhary",
            date: "April 10, 2025"
        },
        {
            id: 5,
            rating: 4.8,
            icon: male,
            title: "Highly Recommended",
            comment: "It was indeed a great experience, Dr Amit is very experienced and his handling of patients is really caring",
            reviewer: "Amul Gautam",
            date: "June 20, 2025"
        },
        {
            id: 6,
            rating: 4.2,
            icon: female,
            title: "Thankyou so much Dr. Amit🙏\n",
            comment: "Thank you for being so caring and attentive\". \"I appreciate your genuine concern and expertise\". \"I am thankful for the positive impact you have made through your expertise and compassionate.",
            reviewer: "Tripti S. Rajput",
            date: "Jan 2, 2025"
        },
        {
            id: 7,
            icon: male,
            rating: 5.0,
            title: "Impressed",
            comment: "The facility itself is clean, modern, and well-organized, which certainly adds to the overall positive experience. I was impressed by the state-of-the-art medical equipment and the attention to detail in maintaining a sanitized environment.",
            reviewer: "Ram Singh",
            date: "Dec 10, 2024"
        },
        {
            id: 8,
            rating: 4.8,
            icon: male,
            title: "Thank you for patient care first!",
            comment: "Overall, my visit to VEM Urgent Care  was a positive one. I left feeling cared for and confident in the treatment I received. It's evident that the team at VEM is committed to providing high-quality care while ensuring that each patient feels valued and respected. I highly recommend VEM Urgent Care to anyone in need of immediate medical attention or assistance. Thank you, VEM, for putting patient care first!",
            reviewer: "Harsh",
            date: "Jan 22, 2025"
        },
        {
            id: 6,
            rating: 4.9,
            icon: male,
            title: "Recommended",
            comment: "Dr. Amit is well trained and has a vast amount of knowledge in his field. He is always able to quickly identify my health issues.\n",
            reviewer: "Abhishyant Nagar",
            date: "Jan 2, 2025"
        }
    ];

    return (
        <Box py={6} sx={{ background: '#FFFFFF' }}>
            <Container>
                <Typography color="primary.main" fontWeight={600} textAlign="center">
                    Testimonials
                </Typography>
                <Typography textAlign="center" variant="h2" mb={2}>
                    What People Say About Us
                </Typography>

                <Grid container spacing={4}>
                    {reviewsData.map((data) => (
                        <Grid item xs={12} sm={6} md={4} key={data.id}>
                            <ReviewsCard data={data} />
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
}
